import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import {
  Quote,
  SubmissionNotification,
  StatusType,
} from "@platform/carrier-tracker-components";
import { Alert, Button, Typography } from "@platform/design-system";
import { JSX } from "react";

function ErrorProposalDialog({
  proposal,
  onClose,
}: {
  proposal: Proposal;
  onClose: VoidFunction;
}): JSX.Element {
  return (
    <Dialog
      open
      onClose={onClose}
      aria-labelledby="error-proposal-dialog-title"
    >
      <DialogTitle id="error-proposal-dialog-title">
        Carrier Failure
      </DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        <Typography>
          Carrier rejected this RFP submission. We&apos;re currently
          investigating the issue and will reach out to you with updates as soon
          as we have more information.
        </Typography>
        <Typography>Eco RFP ID: {proposal.ecoRfpId}</Typography>
        {proposal.errors?.length > 0 ? (
          <Alert severity="error" title="Message from carrier:">
            {proposal.errors.map((error) => (
              <TransmissionError
                key={error.transmissionId}
                transmissionId={error.transmissionId}
                errorData={error.errorData}
                text={error.text}
              />
            ))}
          </Alert>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button variant="tertiary" onClick={onClose}>
          close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const TransmissionError = ({
  transmissionId,
  errorData,
  text,
}: {
  transmissionId: string;
  errorData: string;
  text: string;
}) => (
  <Box>
    <Typography variant="caption">
      <strong>Transmission ID: {transmissionId}</strong>
    </Typography>
    <Box padding={2} border={1} borderRadius={1} borderColor="divider">
      <Box
        component="pre"
        sx={{
          wordBreak: "break-word",
          whiteSpace: "pre-wrap",
          fontFamily: "monospace",
        }}
      >
        {errorData}
      </Box>
      <Typography variant="body-medium" color="inherit">
        {text}
      </Typography>
    </Box>
  </Box>
);

type Proposal = {
  id: number;
  submittedDate: string;
  ecoRfpId: string;
  quotes: Quote[];
  errors: SubmissionNotification[];
  current: StatusType;
  next: StatusType[];
  ecoRfpVersion: string;
};

export default ErrorProposalDialog;
export { Proposal };
